export default __webpack_public_path__ + "static/media/tp-barbearia.cd260263.webp";